var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9948 2.33203C7.56646 2.33203 2.32812 7.57036 2.32812 13.9987C2.32812 20.427 7.56646 25.6654 13.9948 25.6654C20.4231 25.6654 25.6615 20.427 25.6615 13.9987C25.6615 7.57036 20.4231 2.33203 13.9948 2.33203ZM13.1198 9.33203C13.1198 8.8537 13.5165 8.45703 13.9948 8.45703C14.4731 8.45703 14.8698 8.8537 14.8698 9.33203V15.1654C14.8698 15.6437 14.4731 16.0404 13.9948 16.0404C13.5165 16.0404 13.1198 15.6437 13.1198 15.1654V9.33203ZM15.0681 19.1087C15.0098 19.2604 14.9281 19.377 14.8231 19.4937C14.7065 19.5987 14.5781 19.6804 14.4381 19.7387C14.2981 19.797 14.1465 19.832 13.9948 19.832C13.8431 19.832 13.6915 19.797 13.5515 19.7387C13.4115 19.6804 13.2831 19.5987 13.1665 19.4937C13.0615 19.377 12.9798 19.2604 12.9215 19.1087C12.8631 18.9687 12.8281 18.817 12.8281 18.6654C12.8281 18.5137 12.8631 18.362 12.9215 18.222C12.9798 18.082 13.0615 17.9537 13.1665 17.837C13.2831 17.732 13.4115 17.6504 13.5515 17.592C13.8315 17.4754 14.1581 17.4754 14.4381 17.592C14.5781 17.6504 14.7065 17.732 14.8231 17.837C14.9281 17.9537 15.0098 18.082 15.0681 18.222C15.1265 18.362 15.1615 18.5137 15.1615 18.6654C15.1615 18.817 15.1265 18.9687 15.0681 19.1087Z",
    fill: "#F58925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.4fb959807c00d0d6e4ad0264f9acf385.svg";
export { ForwardRef as ReactComponent };